import { BIWEEKLY, MONTHLY, SEMI_MONTHLY, WEEKLY } from 'helpers/Constants';
import { clearNextPayrollDate } from 'reg_redesign/actions';
import { mapDispatchButtonGroup } from 'reg_redesign/redux/connectFunctions';
import ButtonGroup from '@opploans/button-group-component/ButtonGroup';
import configureProgressBar from 'reg_redesign/config/configureProgressBar';
import configureTitle from 'reg_redesign/config/configureTitle';
import nextButtonConfig from 'reg_redesign/config/nextButtonConfig';

const PAYMENT_FREQUENCY_OPTIONS = [
  {
    displayValue: 'Once a week',
    id: 'paymentFrequencyWeekly',
    value: WEEKLY
  },
  {
    displayValue: 'Once every two weeks',
    id: 'paymentFrequencyBiweekly',
    value: BIWEEKLY
  },
  {
    displayValue: 'Once a month',
    id: 'paymentFrequencyMonthly',
    value: MONTHLY
  },
  {
    displayValue: 'Twice a month',
    id: 'paymentFrequencySemiMonthly',
    value: SEMI_MONTHLY
  }
];

const page8 = {
  defaultNextPage: 'page-8.1',
  content: [
    configureProgressBar(36),
    configureTitle('How often are you paid?'),
    {
      component: ButtonGroup,
      name: 'paymentFrequency',
      dispatchOverride: mapDispatchButtonGroup,
      props: {
        id: 'paymentFrequency',
        onClick: clearNextPayrollDate,
        direction: 'column',
        options: PAYMENT_FREQUENCY_OPTIONS
      }
    },
    nextButtonConfig('page-8')
  ]
};
export default page8;
